export default "__VITE_ASSET__14a56f41__"